export default function composeMimeType(mainType: string, subType: string): string {
    return mainType + '/' + subType;
}

export const mimeType = (mainType: string, subType: string): MimeTypeStruct => ({ subType, mainType });
